<template>
	<transition name="modal">
		<div class="modalDialog modal-dialog-centered" v-if="showModal">
			<div class="outsider modal-content">
				<div class="head-modal pl-0 pr-0" v-if="!$slots.header">
					<button class="btn"> <img src="../assets/modal_x.svg" class="close-modal ml-2" @click="modalHide"> </button>
					<div class="pt-3"></div>
					<slot name="title">
					</slot>
					<hr>
				</div>
				<slot v-else name="header"></slot>
				<div class="body-modal" :class="modalHigh ? 'body-modal-75': ''">
					<div class="px-0 px-lg-3">
						<slot name="body">
						</slot>
					</div>
				</div>
				<div class="footer-modal">
					<div class="d-md-flex align-items-center" v-if="!$slots.footer">
						<hr>
						<div class="col my-2 d-flex align-items-center justify-content-md-end justify-content-center p-md-0">
							<a href="javascript:;" @click="modalHide" class="btn btn-outline-danger text-capitalize m-auto text-center br-10 px-5 text-sm-left"><i class="fas fa-times mr-3"></i>Tutup</a>
						</div>
					</div>
					<slot v-else name="footer" >
					</slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	export default {
		name:'VModal',
		data: () => ({
			showModal:false,
		}),
		props: {
			modalHigh: {
				type: Boolean
			},
		},
		methods:{
			modalShow(){
				this.showModal = true
			},
			modalHide(){
				this.showModal = false
			},
		},
		watch: {
			showModal: function() {
				if(this.showModal){
					document.documentElement.style.overflow = 'hidden'
					return
				} else {
					document.documentElement.style.overflow = 'auto'
				}
				
			}
		},
	}
</script>

<style>
.VModal{
	overflow-x: hidden;
	overflow-y: auto;
}
.modalDialog {
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 99999;
	-webkit-transition: opacity 100ms ease-in;
	-moz-transition: opacity 100ms ease-in;
	transition: opacity 100ms ease-in;
	pointer-events: auto;
}
.modalDialog:target {
	opacity: 1;
	pointer-events: auto;
}
.modalDialog .outsider {
	max-width: 800px;
	position: relative;
	margin: 3% auto;
	border-radius: 10px;
	background: #fff;
}
.close-modal {
	color: #fff;
	position: absolute;
	text-align: center;
	top: 30px;
	right: 20px;
	font-size: 25px;
	text-decoration: none;
}
.head-modal {
	background-color: transparent;
	margin-top: 0px;
	padding-top: 0px;
	border-top-left-radius: 10px;
	border-top-right-radius: 10px;
}
.body-modal {
	max-height: 55vh;
	overflow-y: auto;
	overflow-x: hidden !important;
	overflow-y: auto !important;
}
.body-modal-75 {
	max-height: 75vh !important;
	
}
.head-modal h4 {
	text-align: left;
	margin: 0;
	color: rgb(12, 12, 12);
	font-weight: 300;
}
.modal-big .outsider {
	max-width: 1140px;
}
.modal-small .outsider {
	max-width: 500px;
}
#owl-menu .owl-theme .owl-nav {
	margin-top: -35px;
	text-align: center;
	-webkit-tap-highlight-color: transparent;
}
#owl-menu .owl-prev{
	float: left;
	font-family: 'fontawesome';
	margin-left: -50px;
}
#owl-menu .owl-next{
	float: right;
}
.form-wrap {
	display: flex;
	flex-wrap: wrap;
}
hr{
	margin-bottom: 0px !important;
}
.btn{
	font-size: 12px !important;
}
.konfirmasi .modal-body{
	padding: 0px;
}

@media (max-width: 1440px) {
	.modalDialog {
		overflow: hidden;
	}
}

@media (max-width: 768px) {
	.modalDialog {
		overflow: scroll;
	}
}

@media (max-width: 767px) {
	.body-modal {
		padding: 20px 20px 0;
	}
}

@media (max-width: 425px) {
	.modalDialog .outsider {
		width: 95%;
	}
}

@media (min-width: 1441px) and (max-width: 1920px) {
	.modal-big .body-modal {
		max-height: 71vh;
	}
}

</style>